import React from 'react';

const Footer = () => {
    const year = new Date().getFullYear();
    return (
       <section className="min-h-fit flex flex-col justify-start items-center pt-16 px-5 text-center">
        <p className="max-w-xl font-light text-gray-500 mb-10">© {year} Greetings From Dipongkor Roy 🙋🏻‍♂️</p>
       </section>
    );
};

export default Footer;
